<template>
  <tr>
    <td>

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
            </span>
          </div>
        </v-card>
      </v-menu>
      
      <text-highlight class="text-truncate" :queries="nameKeywords" highlightClass="color1--text" highlightStyle="background: none;">{{ ( item.definition || {}).name || 'deleted item' }}</text-highlight>
      
    </td>
    <td>
      <div
      class="rlink-hover color1--text"
      style="text-decoration: none;display:inline-flex;align-items: center;"
      @click.stop="$root.$timelineNav.open(item.archive_id)">
        <v-icon small color="color1" style="transition: none;">mdi-qrcode-scan</v-icon>
        <span class="ml-1">{{ item.archive_id }}</span>
      </div>
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue="item.quantity"
      :key="(item.definition || {}).id"
      alwaysScale
      labelMode
      ></c-ms-ii>
    </td>
    <td>
      {{ item.price_per_unit }}
    </td>
    <td>
      {{ item.value }}
    </td>
    <td>
      <v-row>
        <v-chip v-for="(timeline, i) in item.timelines" :key="i">
            <span
            class="underline-link caption"
            @click.stop="$root.$timelineNav.open(timeline.archive_id)">
              RID:
              {{ timeline.archive_id }}
            </span>
            <!-- <json-inspector :item="item"></json-inspector> -->
        </v-chip>
      </v-row>
    </td>
  </tr>
</template>

<script>
import TextHighlight from 'vue-text-highlight'

export default {
  props: ['item', 'searchFilters'],
  components: {
    TextHighlight
  },
  data () {
    return {
      
    }
  },
  computed: {
    nameKeywords () {
      return (this.searchFilters.name || '').trim().split(/\s+/)
    }
  }
}
</script>